import type { CalculationType, DriverCalculations } from "@/types/Calculation";
import { type Price } from "@/types/Price";
import Api from "./Api";

export class CalculationsApi {
  static async runCalculations(formId: string, calculation_type: CalculationType) {
    return await Api.post(`form-submission/${formId}/run-calculations/`, { calculation_type });
  }

  static async getPrice() {
    const { data } = await Api.get<Price>("product/");
    return data;
  }

  static async getFreeResults(formId: string): Promise<DriverCalculations> {
    const { data } = await Api.get<DriverCalculations>(
      `form-submission/${formId}/retrieve-savings/`,
    );
    return data;
  }
}
